import React from 'react';
import { motion } from 'framer-motion';
import ScrollReveal from './ScrollReveal';
import './ValuesGrid.css';

const VALUES = [
  { title: 'Radical empathy', description: 'People at the center of everything', tag: 'HUMANITY' },
  { title: 'Purpose-driven commitment', description: 'Mission first, trends second', tag: 'PURPOSE' },
  { title: 'Responsible excellence', description: 'Do better with less', tag: 'EXCELLENCE' },
  { title: 'Ego-free collaboration', description: 'Progress is collective, not individual', tag: 'TEAMWORK' },
  { title: 'Rigor with flexibility', description: 'Move fast without breaking science', tag: 'BALANCE' },
  { title: 'Building with integrity', description: 'Trusted even when no one is watching', tag: 'TRUST' },
];

const ValuesGrid: React.FC = () => (
  <section className="values-premium">
    <div className="container">
      <ScrollReveal>
        <h2 className="values-premium__title">Our Values</h2>
      </ScrollReveal>
      <div className="values-premium__grid">
        {VALUES.map((value, index) => (
          <motion.div
            key={value.tag}
            className="values-premium__card"
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.06, duration: 0.45 }}
          >
            <h3>{value.title}</h3>
            <p>{value.description}</p>
            <span className="values-premium__tag">{value.tag}</span>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default ValuesGrid;
